import { useLanguageContext } from "../../../../context/LanguageContext";
import { StyledInput } from "../../../../styles/InputStyles";
import Select from "../../../select/main/Select";

function FlowFieldInputView({ flowField, value, onChange, disabled = false }) {
  const { translate, translateEntity } = useLanguageContext();

  if (flowField.field) {
    switch (flowField.field.type) {
      case "text":
      case "date":
      case "time":
        return (
          <StyledInput
            value={value ?? ""}
            onChange={(e) => onChange(flowField, e.target.value)}
            type={flowField.field.type}
            placeholder={translateEntity(flowField.field, "label")}
            disabled={disabled}
            readOnly={disabled}
          />
        );
      case "select":
      case "boolean":
        return (
          <Select
            value={value}
            nullable={true}
            onChange={(value) => onChange(flowField, value)}
            options={
              flowField.field.type === "boolean"
                ? [
                    { value: "1", label: translate("eva.main.general.yes") },
                    { value: "0", label: translate("eva.main.general.no") },
                  ]
                : flowField.field.options.map((option) => ({
                    value: option.id,
                    label: translateEntity(option, "label"),
                  }))
            }
            disabled={disabled}
          />
        );
      default:
        return null;
    }
  } else {
    switch (flowField.default_field) {
      case "email":
      case "license_plate":
        return (
          <StyledInput
            value={value ?? ""}
            onChange={(e) => onChange(flowField, e.target.value)}
            type="text"
            placeholder={translate(`eva.main.validation.attributes.${flowField.default_field}`)}
            disabled={disabled}
            readOnly={disabled}
          />
        );

      default:
        return null;
    }
  }
}

export default FlowFieldInputView;
